import { LinkNode, TextNode, setCustomComponents } from 'markstream-vue';
import Chat from '@/src/vue/components/Chat/Chat.vue';
import ChatMarkdownImage from '@/src/vue/components/Chat/ChatMarkdownImage.vue';
import { createVueApp } from '@/src/vue/utils/createVueApp';
import { documentReady } from '@js/utils/toolbox';

documentReady(() => {
	const app = createVueApp(Chat);

	setCustomComponents({
		math_inline: props => h(TextNode, {
			...props,
			node: {
				...props.node,
				content: props.node.raw
			}
		}),
		math_block: TextNode,
		strikethrough: TextNode,
		image: ChatMarkdownImage,
		link: props => h(LinkNode, {
			...props,
			showTooltip: false
		})
	});


	app.mount('[data-chat-container]');
});
